/* eslint-disable ember/no-classic-components, ember/require-tagless-components, warp-drive/no-legacy-request-patterns */
import Component from '@ember/component';
import { action } from '@ember/object';
import { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import Jurisdiction from '@linc-technologies/linced-common/enums/jurisdiction';

export default class PreEnrol extends Component {
  @service
  session;

  @service
  store;

  @tracked
  step = 0;

  @action
  setStep(value) {
    this.step = value;
  }

  @tracked
  processing = false;

  @tracked
  intendedStartDate = '';

  @action
  setIntendedStartDate(value) {
    this.intendedStartDate = value;
  }

  person = null;

  @action
  preEnrol() {
    this.processing = true;

    let personPromise = Promise.resolve();
    if (this.person.hasDirtyAttributes) {
      // NSN was likely set/updated as part of the process.  Save it.
      personPromise = this.person.save();
    }

    personPromise.then(() => {
      let enrolment = this.store.createRecord('people/enrolment', {
        schoolId: this.session.school,
        personId: this.person.id,
        jurisdiction: Jurisdiction.NZ_MOE,
        jurisdictionalId: this.person.jurisdictionalId,
        entryDate: this.intendedStartDate,
        // Fragments can only belong to one owner, so seed the enrolment with
        // copies rather than the person's own fragments.
        fieldsArray: this.person.fieldsArray.copy(),
        learner: this.person.learner.copy(),
        profileMedia: this.person.profileMedia,
      });

      enrolment.save().then(() => {
        this.processing = false;
        this.onPreEnrolled();
      });
    });
  }
}
